function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "energy-inactive");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.74,7.84a.89.89,0,0,1,0,1.26l-.63.63a.89.89,0,0,1-1.26,0L5,6.9,2.16,9.74a.89.89,0,0,1-1.26,0L.26,9.11a.89.89,0,0,1,0-1.26L3.1,5,.26,2.16A.89.89,0,0,1,.26.89L.89.26a.89.89,0,0,1,1.26,0L5,3.1,7.84.26a.89.89,0,0,1,1.26,0l.63.63a.89.89,0,0,1,0,1.26L6.9,5Z",
  fill: "#131548"
});

var SvgEnergyInactive = function SvgEnergyInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnergyInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/energy-inactive.6286c232.svg";
export { ForwardRef as ReactComponent };